module.exports = __webpack_public_path__ + "img/badge_previdenza.17848dd8.jpg";